export default __webpack_public_path__ + "static/superhuman-ai-1-5ae1bd5e8503025f6c5cf958babfc092.png";